import { render, staticRenderFns } from "./PaymentCheck.vue?vue&type=template&id=2b7125f8&scoped=true"
import script from "./PaymentCheck.vue?vue&type=script&lang=js"
export * from "./PaymentCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7125f8",
  null
  
)

export default component.exports